/** Anzeige-Templates der Rechnungs-View — Port von `IwmColumnsRechnung.razor`. */

import type { Receipt } from '@/types/entities';

import { DateCell } from './shared/DateCell';
import { DecimalCell } from './shared/DecimalCell';
import type { CellTemplateMap } from './types';

export const receiptCellTemplates: CellTemplateMap<Receipt> = {
  // Decimals
  GesamtbetragNettoEuro: (model) => <DecimalCell value={model.GesamtbetragNettoEuro} suffix="€" />,
  GesamtbetragNetto: (model) => <DecimalCell value={model.GesamtbetragNetto} />,
  Kurs: (model) => <DecimalCell value={model.Kurs} format="N4" />,

  Rechnungszuordnung_Container_Bestellposition_SageBuchungDatum: (model) => (
    <DateCell value={model.Rechnungszuordnung_Container_Bestellposition_SageBuchungDatum} />
  ),
  // Original: `ToString("F0")` — feste Nachkommastellen ohne Tausendertrennzeichen.
  // Das `<span>` wird auch ohne Wert ausgegeben (anders als bei `DecimalCell`).
  Rechnungszuordnung_Container_Bestellposition_BuchungsperiodeWare: (model) => (
    <span style={{ float: 'right' }}>
      {model.Rechnungszuordnung_Container_Bestellposition_BuchungsperiodeWare?.toFixed(0)}
    </span>
  ),
};

export default receiptCellTemplates;
